var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21.681,
    height: 21.681,
    viewBox: "0 0 21.681 21.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1220",
    "data-name": "Rectangle 1220",
    width: 21.681,
    height: 21.681,
    transform: "translate(0 0)",
    fill: "#ffbdbf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3551",
    "data-name": "Group 3551",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4637",
    "data-name": "Path 4637",
    d: "M104.2,619.744l-8.441-7.5a.938.938,0,0,0-1.562.7v3.008C91.379,616.7,82,620.224,82,633.576a.938.938,0,0,0,1.808.348c2.781-6.953,8.2-8.4,10.384-8.707v2.731a.938.938,0,0,0,1.563.7l8.441-7.5a.938.938,0,0,0,0-1.4Z",
    transform: "translate(-82.289 -612.541)",
    fill: "#ffbdbf"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendArrow);
export default __webpack_public_path__ + "static/media/sendArrow.7b150a068cdc7d8b1292b4c30c7811bd.svg";
export { ForwardRef as ReactComponent };